import styled, { css, keyframes } from 'styled-components';

const frames = keyframes`
  0% {
    left: 0%;
    right: 100%;
    width: 0%;
  }
  10% {
    left: 0%;
    right: 75%;
    width: 25%;
  }
  90% {
    right: 0%;
    left: 75%;
    width: 25%;
  }
  100% {
    left: 100%;
    right: 0%;
    width: 0%;
  }
`;

const framesRules = css`
  ${frames} 1s linear infinite;
`;

export default styled.div`
  width: 100%;
  margin: 0 auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 1px;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 100%;
    bottom: 0;
    left: 0;
    background: var(--primary);
    width: 0;
    animation: ${framesRules};
  }
`;
